import {
  ExclamationCircleIcon,
  ChartBarIcon as ChartBarIconSolid,
} from "@heroicons/react/20/solid";
import { ChartBarIcon } from "@heroicons/react/24/outline";
import { QuestionPriority } from "../graphql/generated";

// Function to normalize priority values - handles both enum values and strings
function normalizePriority(
  priority?: QuestionPriority | string | null,
): QuestionPriority {
  if (!priority || priority === null) return QuestionPriority.None;

  // If it's already an enum value, return it
  if (typeof priority === "number") return priority as QuestionPriority;

  // Handle string values
  switch (priority.toUpperCase()) {
    case "NONE":
      return QuestionPriority.None;
    case "LOW":
      return QuestionPriority.Low;
    case "MEDIUM":
      return QuestionPriority.Medium;
    case "HIGH":
      return QuestionPriority.High;
    case "URGENT":
      return QuestionPriority.Urgent;
    default:
      return QuestionPriority.None;
  }
}

export function QuestionPriorityIcon(props: {
  priority?: QuestionPriority | string | null;
}) {
  const normalizedPriority = normalizePriority(props.priority);

  if (!props.priority || normalizedPriority === QuestionPriority.None) {
    return (
      <ChartBarIcon className="w-3 h-3 text-gray-400 opacity-50 flex-shrink-0" />
    );
  }

  switch (normalizedPriority) {
    case QuestionPriority.Low:
      return <ChartBarIcon className="w-3 h-3 text-gray-400 flex-shrink-0" />;
    case QuestionPriority.Medium:
      return (
        <ChartBarIconSolid className="w-3 h-3 text-gray-400 flex-shrink-0" />
      );
    case QuestionPriority.High:
      return (
        <ChartBarIconSolid className="w-3 h-3 text-gray-700 flex-shrink-0" />
      );
    case QuestionPriority.Urgent:
      return (
        <ExclamationCircleIcon className="w-3 h-3 text-orange-500 flex-shrink-0" />
      );
    default:
      return (
        <ChartBarIcon className="w-3 h-3 text-gray-400 opacity-50 flex-shrink-0" />
      );
  }
}

export function getQuestionPriorityText(
  priority?: QuestionPriority | string | null,
) {
  if (!priority) {
    return "No priority";
  }

  const normalizedPriority = normalizePriority(priority);

  switch (normalizedPriority) {
    case QuestionPriority.Low:
      return "Low";
    case QuestionPriority.Medium:
      return "Medium";
    case QuestionPriority.High:
      return "High";
    case QuestionPriority.Urgent:
      return "Urgent";
    case QuestionPriority.None:
      return "None";
    default:
      return "";
  }
}
